export const OPTION_LIST = ['pricing', 'demo request', 'feedback', 'support', 'other'];
